import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';
import { schemaStoreStates } from '../../hooks/useSchemasHook';

const schemaActions = mapDefaultValuesToActions(schemaStoreStates);

export default reduxReducerHelper(schemaActions, schemaStoreStates);
